import { Injectable } from '@angular/core';
import { ApiClientService } from '../api-client.service';
import { Observable } from 'rxjs/Observable';
import { IReport } from '../../types/api-response/report/report';
import { catchError, flatMap, skipWhile, take } from 'rxjs/operators';
import { ReportStatus } from '../../types/api-response/report/report-status';
import { interval } from 'rxjs/observable/interval';
import { IExtractReportDetails } from '../../types/api-response/report/extract-email-units';
import { ApiResponseList } from '../../types/api-response/helpers';

@Injectable()
export class ReportBuilderApiService {

    constructor(private api: ApiClientService) {
    }

    /**
     * Returns available reports list
     */
    getReportsList(): Observable<ApiResponseList<IReport>> {
        return this.api.getJson('domainReportGenerator', '/v1/reports').pipe(
            catchError(error => {
                this.api.errorHandler('Failed to get reports list');

                return Observable.throw(error);
            })
        );
    }

    /**
     * Runs report building process
     *
     * @param templateId
     * @param name
     */
    runReportBuild(templateId, name = ''): Observable<{ id: string }> {
        name = name || 'Report ' + new Date().toLocaleString();
        const url = `/v1/reports/template-${templateId}`;

        return this.api.post('domainReportGenerator', url, {name});
    }

    /**
     * Returns report details
     *
     * @param reportId
     */
    getReportDetails(reportId): Observable<IReport> {
        const url = `/v1/reports/${reportId}.json`;

        return this.api.getJson('domainReportGenerator', url);
    }

    /**
     * Checks report status until it's ready or fail
     *
     * @param reportId
     * @param checkInterval
     */
    waitReportDetails(reportId, checkInterval = 5): Observable<IReport> {
        return interval(checkInterval * 1000).pipe(
            flatMap(() => this.getReportDetails(reportId)),
            skipWhile(report => [ReportStatus.wait, ReportStatus.in_progress].includes(report.status)),
            take(1)
        );
    }

    /**
     * Returns report emails list
     * @param reportId
     */
    extractReportEmails(reportId): Observable<string[]> {
        const url = `/v1/reports/extract/emails/${reportId}`;

        return this.api.getJson('domainReportGenerator', url);
    }

    /**
     * Returns report units list
     *
     * @param reportId
     */
    extractReportDetails(reportId): Observable<IExtractReportDetails> {
        const url = `/v1/reports/extract/${reportId}/eus`;

        return this.api.getJson('domainReportGenerator', url).pipe(
            catchError(error => {
                this.api.errorHandler('Failed to get emails and units by report');

                return Observable.throw(error);
            })
        );
    }
}



// WEBPACK FOOTER //
// /app/src/app/services/api/report-builder-api.service.ts